import fakeLocalStorage from "./fakeLocalStorage";
import { LOCAL_STORAGE_KEYES } from "./localStorageTypes";

export const getLocalStorageObj = (key) => {
  try {
    return JSON.parse(fakeLocalStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

export const getLocalStorageItem = (key) => {
  try {
    return fakeLocalStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const removeLSItem = (key) => fakeLocalStorage.removeItem(key);



export class LocalStorage {

  static getLocalStorageObject(key) {
    try {
      return JSON.parse(fakeLocalStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }
  static setLocalStorageItem(key, value) {

  }

  static getLocalStorageItem(key) {
    return fakeLocalStorage.getItem(key);
  }

  static isKeyExist(key) {
    return !!getLocalStorageItem(key)
  }

  static getTableSettings() {
    return this.getLocalStorageObject(LOCAL_STORAGE_KEYES.BUM_TABLE_SETTINGS)
  }

  static isTableSettingsExist() {
    return !!this.isKeyExist(LOCAL_STORAGE_KEYES.BUM_TABLE_SETTINGS)
  }

}